export const DEFAULT_CODE_EXPIRY_IN_DAYS = 365;
